import useLayoutStore from "@/store/create/createLayoutStore"
import mineStore from "@/store/mineDataStore"

const isSSR = import.meta.env.SSR

const layoutConfig = {
  renderType: 'pc',
}

export const initLayout = () => {
  if (typeof window !== 'undefined') {
    layoutConfig.renderType = window?.innerWidth <= 768 ? 'mobile' : 'pc'
    useLayoutStore().setRenderType(layoutConfig.renderType)
    mineStore().isMobile = layoutConfig.renderType === 'mobile'
    return
  }
}

export const initLayoutSSR = (app,userAgent) => {
  const ua = userAgent ?? (typeof window !== 'undefined' ? navigator.userAgent : '');
  const mobilePattern = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Mobile|Opera Mini|Windows Phone|Kindle|Silk/i;
  const isMobile = mobilePattern.test(ua);
  layoutConfig.renderType = isMobile ? 'mobile' : 'pc'
  useLayoutStore().createRenderType = layoutConfig.renderType
  mineStore().isMobile = layoutConfig.renderType === 'mobile'
}

export default layoutConfig